/* <product-form>: AJAX add to cart for any Shopify product form inside it.
   Posts to /cart/add.js with the cart drawer + header bubble sections, then publishes `cart:update`
   (the cart drawer re-renders and opens). With the "cart page" setting it redirects to /cart instead.
   Errors show in [data-product-form-error] inside the element (created if missing).
   Bundle offer: a [data-offer-free] input with a value > 0 (product page / quick view bundle) adds the free packs in
   the same request as their own line (property _offer_free, see global.js) and shows "2 packs + 1 free added". */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form || this.form.dataset.bound) return;
      this.form.dataset.bound = 'true';
      this.form.addEventListener('submit', e => this.onSubmit(e));
    }

    get submitButton() { return this.form.querySelector('[type="submit"]'); }

    async onSubmit(e) {
      e.preventDefault();
      const button = e.submitter || this.submitButton;
      if (!button || button.getAttribute('aria-disabled') === 'true' || button.classList.contains('is-loading')) return;
      if (theme.settings?.cartType === 'page') { this.form.submit(); return; }

      this.setError();
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');

      const body = new FormData(this.form);
      const drawer = document.querySelector('cart-drawer');
      body.append('sections', 'cart-drawer,cart-icon-bubble');
      body.append('sections_url', window.location.pathname);

      const offerFree = this.form.querySelector('[data-offer-free]');
      const freeQty = parseInt(offerFree?.value, 10) || 0;
      let request = body, headers = { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' };
      if (freeQty > 0) {
        const id = Number(body.get('id')), quantity = parseInt(body.get('quantity'), 10) || 1;
        const properties = {}, sellingPlan = body.get('selling_plan');
        for (const [k, v] of body.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m) properties[m[1]] = v; }
        request = JSON.stringify({
          items: [{ id, quantity, properties, ...(sellingPlan && { selling_plan: Number(sellingPlan) }) }, { id, quantity: freeQty, properties: { _offer_free: '1' } }],
          sections: body.get('sections'), sections_url: body.get('sections_url')
        });
        headers = { ...headers, 'Content-Type': 'application/json' };
      }

      try {
        const res = await fetch(`${theme.routes.cart_add_url}.js`, { method: 'POST', body: request, headers });
        const data = await res.json();
        if (data.status) {
          this.setError(data.description || data.message || theme.strings.cartError);
          theme.publish('cart:error', { source: 'product-form', error: data });
          return;
        }
        theme.publish('cart:update', { source: 'product-form', productVariantId: body.get('id'), item: data, sections: data.sections });
        if (freeQty > 0 && offerFree.dataset.notice) {
          theme.showCartNotice(offerFree.dataset.notice.replace('[paid]', body.get('quantity')).replace('[free]', freeQty));
        }
        this.dispatchEvent(new CustomEvent('product-form:added', { bubbles: true, detail: data }));
        if (!drawer) { window.location.href = theme.routes.cart_url; return; }
        // close any open quick view first, then show the drawer
        const qv = document.getElementById('QuickView');
        if (qv && !qv.hidden && qv.close) qv.close({ restoreFocus: false });
        drawer.open?.(button);
      } catch {
        this.setError(theme.strings.cartError);
      } finally {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      }
    }

    setError(message) {
      let el = this.querySelector('[data-product-form-error]');
      if (!message) { if (el) { el.hidden = true; el.textContent = ''; } return; }
      if (!el) {
        el = document.createElement('p');
        el.className = 'form-message form-message--error product-form__error';
        el.dataset.productFormError = '';
        el.setAttribute('role', 'alert');
        this.append(el);
      }
      el.textContent = message;
      el.hidden = false;
    }
  });
}
